import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  buttonBase: {
    '&:hover': {
      cursor: 'pointer',
      filter: 'brightness(90%)',
    },
    '&:active, &:active': {
      filter: 'brightness(85%)',
    },
  },
  panel: {
    background: theme.palette.white,
    transition: 'background 0.2s ease',
    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.neutralBackground,
    },
  },
  text: {
    color: theme.palette.primaryPure,
    background: 'inherit',
    border: 'none',
    fontWeight: 'bold',
  },
  textSecondary: {
    color: theme.palette.secondaryPure,
    background: 'inherit',
    border: 'none',
  },
  primary: {
    padding: '13.5px 16px',
    backgroundColor: theme.palette.primaryPure,
    border: '1px solid #0272D5',
    borderRadius: '6px',
    color: 'white',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '21px',
    flex: 'auto',
    textRendering: 'geometricPrecision',
  },
  icon: {
    opacity: 0.85,
    '&:hover': {
      cursor: 'pointer',
      opacity: 1,
    },
  },
}));

export default useStyles;
